import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '../services/login.service'

@Component({
  selector: 'app-change-pwd',
  templateUrl: './change-pwd.component.html',
  styleUrls: ['./change-pwd.component.css']
})
export class ChangePwdComponent implements OnInit {

  clickStatus = false;
  msg = '';
  flag = true;
  alreadySubmit = false;

  constructor(private ls: LoginService,private router: Router) { 
    /*this.form = fb.group({
      employee_code : ['',Validators.compose([Validators.required,Validators.minLength(3)])],
      password : ['',Validators.required]
    })*/
    
  }
  pwdData = {
    password: '',
    repassword : ''
}

  ngOnInit() {
  }

  isValid(chgForm,control) 
  {
   
    if((!chgForm.controls[control].valid && (chgForm.controls[control].dirty ||chgForm.controls[control].touched)) || (!chgForm.controls[control].valid && this.clickStatus))
    {
       //var errorStr = '<div class="alert alert-danger"> * ' + control+ ' is required</div>';
       var errorStr = '<div class="alert alert-danger"> * ' + 'This field is required</div>';
      return errorStr;
    }
  }
  isMatch(chgForm,control)
  {
    if(this.pwdData.password != this.pwdData.repassword)
       {
        var errorStr = '<div class="alert alert-danger"> * ' + 'Password is not matched</div>';
        this.flag = false;
        return errorStr;
       }
       else{
        this.flag = true;
       }
       
    
  }

  onSubmit(assignL2Form)
  {
    this.clickStatus = true;
    if((assignL2Form.valid) && (this.flag))
    {
     this.alreadySubmit = true;
     //console.log(this.pwdData);
     var result = this.ls.changePwd(this.pwdData).subscribe( res => {
      if(res.status == 200)
      {
        localStorage.setItem('dashboard_msg',res.message);
        this.router.navigate(['/dashboard']);
      }
      else{
        this.msg = res.message;
        return;
      }
     
     })
     
      
    }
   
   
  }



}



// WEBPACK FOOTER //
// ./src/app/change-pwd/change-pwd.component.ts